import {fabric} from "fabric";

export const elementsMix = {
  data() {
    return {

    }
  },
  methods: {
    deleteElementCanvas() {
      this.canvas.getActiveObjects().map((ele) => {
        this.deleteLayoutElement(ele)
        this.canvas.remove(ele)
      })
      this.canvas.discardActiveObject()
      this.canvas.renderAll()
    },
    clickAddPreset(item) // Добавляем логотип или изображение
    {
      const id = this.$uuid.v1();
      const slug = 'logo'
      const index =  !item.isResized ? this.layoutsGroup.findIndex((el) => {return el.slug == slug}): this.currentLayoutCroupIndex
      fabric.Image.fromURL(item.src,
        (img) => {
          this.canvas.add(img).renderAll();
          this.canvas.centerObject(img);
          this.setLayoutSet(img)
        },
        {
          isResized: item.isResized || false,
          event: {type: 'none', value: 0},
          id: id,
          left: 10,
          top: 10,
          angle: 0,
          index:index
        })
    },
    clickAddPresetSvg(item) // Добавляем пресеты
    {
      const id = this.$uuid.v1();
      const slug = 'icon'
      const index = this.layoutsGroup.findIndex((el) => {return el.slug == slug})
      fabric.Image.fromURL(item.src,
        (img) => {
          this.canvas.add(img).renderAll();
          this.canvas.centerObject(img);
          this.setLayoutSet(img)
        }, {
          text: item.title,
          isIcon:true,
          id: id,
          isResized: false,
          left: 10,
          top: 10,
          angle: 0,
          index: index,
          event: {type: 'none', value: 0}
        })
    },
    clickChangeToolText(type, props) // обавляем текст
    {
      const id = this.$uuid.v1();
      const obj = {
        event: {type: 'none', value: 0},
        fontFamily: "Inter",
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontSize: 20,
        textAlign: 'left',
        id: id,
        index: this.currentLayoutCroupIndex,
        stroke: 0,
        strokeWidth: 1,
        fill: "#0F0F0FFF",
        width: 100,
        height: 100,
        left: 10,
        top: 10,
        underline: false,
      };
      const element = new fabric.Textbox("Текст", obj);
      if (element) {
        this.canvas.add(element)
        this.canvas.centerObject(element);
        this.setLayoutSet(element)
      }
    },
    // setStandObject(item)  // @TODO что это?
    // {
    //   let obj = this.canvas.getActiveObjects()
    //   console.log('getActiveObjects', obj)
    //   obj[0].set('event', {
    //     type: 'stand',
    //     value: item.title
    //   })
    //   this.layoutsGroup[this.currentLayoutCroupIndex].objects = this.layoutsGroup[this.currentLayoutCroupIndex].objects.map((el) => {
    //     if (el[4] === obj[0].id) {
    //       el[9] = 'stand'
    //       el[10] = item.title
    //     }
    //     return el
    //   })
    // },
    setLayoutSet(element) // Добавляем в нужный слой/папку
    {
      const indx = element.index || this.currentLayoutCroupIndex
      const group = this.layoutsGroup[indx]
      const title = ['textbox'].includes(element.type) || element.isIcon ? element.text : element.type
      group.objects.unshift([element.type, true, false, true, element.id, element.fill, 1, indx, title, 'none', 0])
      this.changeActiveObjects([element.type, true, false, true, element.id, element.fill, 1, indx, title, 'none', 0])
    },
    setActiveObjectFromCanvas(id) // делаем активным элемент по id
    {
      const obj = this.canvas.getObjects().filter(el => el.id === id)[0]
      this.canvas.setActiveObject(obj)
      this.canvas.renderAll()
    },
    createStandTemplateNew(stand){
      this.currentMode = 'standPaint'
      this.currentStandPaintOptions = stand
    },
    createStandTemplate(stand) // добавляем стенд
    {
      const centerX = this.CenterCoord().x
      const centerY = this.CenterCoord().y
      const standId = stand.id
      let id = this.$uuid.v1();
      let element
      let  index = this.layoutsGroup.findIndex((el, i) => {
        return el.slug == 'stand'
      })
      let group = this.layoutsGroup[index]

      // добавляем квадрат стенда
      let obj = {
        isStand: true,
        standId,
        id,
        strokeWidth: 1,
        stroke: '#9A99A2FF',
        fill: '#7B7A84FF',
        width: 150,
        height: 150,
        noScaleCache: false,
        strokeUniform: true,
        index,
        top: centerY,
        left: centerX
      }
      element = new fabric.Rect(obj);
      element.set('event', {type: 'stand', value: stand.title})
      this.canvas.add(element)
      setS(element, group, index)

      // добавляем название  стенда

      id = this.$uuid.v1()
      obj = {
        standId,
        isStandTitle: true,
        noScaleCache: false,
        strokeUniform: true,
        id,
        fontFamily: "Inter",
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontSize: 20,
        textAlign: 'left',
        index,
        fill: 'white',
        stroke: 0,
        strokeWidth: 1,
        underline: false,
        top:centerY + 5,
        left: centerX + 5,
        text: stand.title,
        event: {type: 'stand', value: stand.title}
      };
      element = new fabric.Textbox("Текст", obj);
      this.canvas.add(element)
      setS(element, group, index)

      // добавляем названия компаний в отдельный слой/папку

      // index = this.layoutsGroup.findIndex((el) => {
      //   return el.slug == 'company'
      // })
      // group = this.layoutsGroup[index]
      // let i = 10
      // stand.companyObjects.map((el) =>
      // {
      //   id = this.$uuid.v1()
      //   obj = {
      //     standId,
      //     isCompanyName: true,
      //     noScaleCache: false,
      //     strokeUniform: true,
      //     id,
      //     fontFamily: "Inter",
      //     fontWeight: 'normal',
      //     fontStyle: 'normal',
      //     fontSize: 20,
      //     textAlign: 'left',
      //     fill: 'white',
      //     index,
      //     stroke: 0,
      //     strokeWidth: 1,
      //     width: 100,
      //     height: 100,
      //     underline: false,
      //     top:centerY + 20 + i,
      //     left:centerX + 10,
      //     text:el.title,
      //     event: {type: 'stand', value: stand.title}
      //   };
      //   element = new fabric.Textbox("Текст", obj);
      //   this.canvas.add(element)
      //   setS(element, group, index)
      //   i = i + 20
      // })
      function setS(element, group, index) {
        let title = ['textbox'].includes(element.type) ? element.text : element.type
        group.objects.unshift([element.type, true, false, false, element.id, element.fill, 1, index, title, 'stand', stand.title])
      }
    },
    CenterCoord() {
      let zoom = this.canvas.getZoom()
      return {
        x: fabric.util.invertTransform(this.canvas.viewportTransform)[4] + (this.canvas.width / zoom) / 2,
        y: fabric.util.invertTransform(this.canvas.viewportTransform)[5] + (this.canvas.height / zoom) / 2
      }
    },
    addCanvasElement(tool, prop) {
      const centerX = this.CenterCoord().x
      const centerY = this.CenterCoord().y
      let element, obj, id = this.$uuid.v1();
      switch (prop) {
        case 'text':
          obj = {
            fontFamily: "Inter",
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontSize: 20,
            textAlign: 'center',
            id: id,
            stroke: 0,
            strokeWidth: 1,
            fill: "#0F0F0FFF",
            width: 50,
            height: 50,
            underline: false,
          };
          element = new fabric.Textbox("Текст", obj);
          break;
        case 'circle':
          obj = {
            originX: 'center',
            originY: 'center',
            centeredScaling: true,
            id: id,
            fill: 'white',
            radius: 25,
            opacity: 1,
            stroke: 'grey',
            strokeWidth: 1,
            noScaleCache: false,
            strokeUniform: true,
          };
          element = new fabric.Circle(obj);
          break;
        case 'square':
          obj = {
            id: id,
            strokeWidth: 1,
            stroke: 'grey',
            fill: 'white',
            width: 50,
            height: 50,
            noScaleCache: false,
            strokeUniform: true,
          }
          element = new fabric.Rect(obj);
          break;
        case 'line':
          element = new fabric.Line([10, 10, 100, 100], {
            id: id,
            stroke: 'grey',
            noScaleCache: false,
            strokeUniform: true,
          });
          break;
        case 'triangle':
          obj = {
            noScaleCache: false,
            strokeUniform: true,
            width: 50,
            height: 50,
            fill: '',
            stroke: 'grey',
            strokeWidth: 1,
            id: id,
            angle: 0,
          }
          element = new fabric.Triangle(obj);
          break;
        default:
      }
      if (element) {
        element.set('index', this.currentLayoutCroupIndex)
        element.set('event', {type: 'none', value: 0})
        element.set('top', centerY - element.height / 2)
        element.set('left', centerX - element.width / 2)
        this.canvas.add(element)
        this.canvas.setActiveObject(element);
        this.setLayoutSet(element)
      }

    },
    centerObjectByViewPort() {
      let object = this.canvas.getActiveObject()
      let objWidth = object.getScaledWidth()
      let objHeight = object.getScaledHeight()
      let zoom = this.canvas.getZoom()
      let panX = 0
      let panY = 0
      panX = ((this.canvas.getWidth() / zoom / 2) - (object.aCoords.tl.x) - (objWidth / 2)) * zoom
      panY = ((this.canvas.getHeight() / zoom / 2) - (object.aCoords.tl.y) - (objHeight / 2)) * zoom
      this.canvas.setViewportTransform([zoom, 0, 0, zoom, panX, panY])
    },
    copyElementByLayout(obj) {
      let help, id = this.$uuid.v1();
      obj.clone((object) => {
        object.set({
          id: id,
          noScaleCache: false,
          strokeUniform: true,
          top: object.top + 15,
          left: object.left + 15,
          index: this.currentLayoutCroupIndex,
          event: {
            type: 'none',
            value: 0
          }
        })
        this.canvas.discardActiveObject()
        this.canvas.add(object);
        this.setLayoutSet(object)
        this.canvas.setActiveObject(object)
      });
    },
    copyElement() {
      let help, id = this.$uuid.v1();
      help = this.canvas.getActiveObject().index
      this.canvas.getActiveObject().clone((object) => {
        object.set({
          id: id,
          noScaleCache: false,
          strokeUniform: true,
          top: object.top + 15,
          left: object.left + 15,
          index: help,
          event: {
            type: 'none',
            value: 0
          }
        })
        this.canvas.discardActiveObject()
        this.canvas.add(object);
        this.setLayoutSet(object)
        this.canvas.setActiveObject(object)
      });
    },
    setLockObjectToggle(id, bool) {
      const index = this.getIndexFromCanvasObjectsFromId(id)
      let obj = this.getObjectFromCanvasObjectsByIndex(index)
      obj.hasBorders = !obj.hasBorders
      obj.hasControls = !obj.hasControls
      obj.lockMovementY = !obj.lockMovementY
      obj.lockMovementX = !obj.lockMovementX
      obj.lockRotation = !obj.lockRotation
      obj.selectable = !obj.selectable

      let indexA = this.layoutsGroup[obj.index].objects.map(el => el[4]).indexOf(id)
      let arr = this.layoutsGroup[obj.index].objects.map((el, i) => {
        if (i === indexA) el[2] = bool
        return el
      })
      this.canvas.discardActiveObject()
      this.layoutsGroup[obj.index].objects = arr

    },
    setLockObject(id) {
      const index = this.getIndexFromCanvasObjectsFromId(id)
      let obj = this.getObjectFromCanvasObjectsByIndex(index)
      obj.hasBorders = !obj.hasBorders
      obj.hasControls = !obj.hasControls
      obj.lockMovementY = !obj.lockMovementY
      obj.lockMovementX = !obj.lockMovementX
      obj.lockRotation = !obj.lockRotation
      obj.selectable = !obj.selectable
      console.log(obj.selectable);
      let indexA = this.layoutsGroup[obj.index].objects.map(el => el[4]).indexOf(id)
      let arr = this.layoutsGroup[obj.index].objects.map((el, i) => {
        if (i === indexA) el[2] = !el[2]
        return el
      })
      this.canvas.discardActiveObject()
      this.layoutsGroup[obj.index].objects = arr

    },
    setVisibleObjectToggle(id, bool) {
      const index = this.getIndexFromCanvasObjectsFromId(id)
      let obj = this.getObjectFromCanvasObjectsByIndex(index)
      obj.set('visible', bool)
      this.canvas.renderAll()
      let indexA = this.layoutsGroup[obj.index].objects.map(el => el[4]).indexOf(id)
      let arr = this.layoutsGroup[obj.index].objects.map((el, i) => {
        if (i === indexA) el[1] = bool
        return el
      })
      this.canvas.discardActiveObject()
      this.layoutsGroup[obj.index].objects = arr

    },
    setVisibleObject(id) {
      const index = this.getIndexFromCanvasObjectsFromId(id)
      let obj = this.getObjectFromCanvasObjectsByIndex(index)
      obj.set('visible', !obj.visible)
      this.canvas.renderAll()
      let indexA = this.layoutsGroup[obj.index].objects.map(el => el[4]).indexOf(id)
      let arr = this.layoutsGroup[obj.index].objects.map((el, i) => {
        if (i === indexA) el[1] = !el[1]
        return el
      })
      this.canvas.discardActiveObject()
      this.layoutsGroup[obj.index].objects = arr
    },
    getIndexFromCanvasObjectsFromId(id) {
      return this.canvas.getObjects().map((x) => {
        return x.id
      }).indexOf(id)
    },
    getIndexFromCanvasObjects(object) {
      return this.canvas.getObjects().map((x) => {
        return x.id
      }).indexOf(object.id)
    },
    getObjectFromCanvasObjectsByIndex(index) {
      return this.canvas.item(index);
    },
    getObjectByCanvasObject(object) {
      const index = this.getIndexFromCanvasObjects(object)
      return this.getObjectFromCanvasObjectsByIndex(index)
    },
    setActiveObject(object) {
      let obj = this.getObjectByCanvasObject(object)
      this.activeObject = obj
      this.canvas.setActiveObject(obj);
      this.canvas.renderAll()
    }
  }
}
